module.exports = __webpack_public_path__ + "static/media/twisting.ae6243f7.mp4";